export default {
    SHOW_SUBSCRIBE_VIEW: 'SHOW_SUBSCRIBE_VIEW',
    CLOSE_SUBSCRIBE_VIEW: 'CLOSE_SUBSCRIBE_VIEW',
    // SET_OPEN_METHOD:'SET_OPEN_METHOD',
    OPEN_CARD_INFO_EDIT_POPUP: 'OPEN_CARD_INFO_EDIT_POPUP',
    CLOSE_CARD_INFO_EDIT_POPUP: 'CLOSE_CARD_INFO_EDIT_POPUP',
    CHANGE_PAY_METHOD: 'CHANGE_PAY_METHOD',
    CHANGE_CURRENT_STEP: 'CHANGE_CURRENT_STEP',
    CHANGE_SELECT_PAGE: 'CHANGE_SELECT_PAGE',
    CHANGE_LOADING_STATUS: 'CHANGE_LOADING_STATUS',
    SET_CURRENT_PLAN: 'SET_CURRENT_PLAN',
    SET_DATA_INFO: 'SET_DATA_INFO',
    SET_DISCOUNT_CONF: 'SET_DISCOUNT_CONF',
    SET_PAYPAL_SDK_STATUS: 'SET_PAYPAL_SDK_STATUS',
    SET_TEAM_SUBSCRIPTION: 'SET_TEAM_INFO',
    UPDATE_SEAT_COUNT: 'UPDATE_SEAT_COUNT',
    UPDATE_IS_ANNUALLY: 'UPDATE_IS_ANNUALLY'
};
